import { Directive, HostListener, Input, output } from '@angular/core';

@Directive({
  selector: '[infLongPress]',
  standalone: true,
})
export class LongPressDirective {
  private timeout: any;

  private startX: number = null;
  private startY: number = null;

  @Input() longPressDelay = 800;

  readonly longPress = output<TouchEvent>();

  @HostListener('touchstart', ['$event'])
  public onTouchStart(event: TouchEvent) {
    this.startX = event.touches[0].clientX;
    this.startY = event.touches[0].clientY;
    this.timeout = setTimeout(() => {
      this.longPress.emit(event);
      this.clearTimeout();
    }, this.longPressDelay);
  }

  @HostListener('touchmove', ['$event'])
  public onTouchMove(event: TouchEvent) {
    const diffX = event.touches[0].clientX - this.startX;
    const diffY = event.touches[0].clientY - this.startY;
    /* istanbul ignore else */
    if (Math.abs(diffX) > 10 || Math.abs(diffY) > 10) {
      this.clearTimeout();
    }
  }

  @HostListener('touchend')
  public onTouchEnd() {
    this.clearTimeout();
  }

  private clearTimeout(): void {
    try {
      clearTimeout(this.timeout);
      this.timeout = null;
    } catch (e) {
      console.error(e);
    }
  }
}
